import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { CallState } from '@lcs/shared/api';
import { Store } from '@ngrx/store';
import { getSelectedAccountId } from 'src/app/store/select-account/select-account.selector';
import { AddUserData } from '../models/add-user-data';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ndt-add-user-view',
    styleUrls: ['./add-user-view.component.scss'],
    templateUrl: './add-user-view.component.html',
    standalone: false
})
export class AddUserViewComponent implements OnInit {
   @Output() formSubmitted = new EventEmitter<AddUserData>();

   @Output() formCanceled = new EventEmitter<void>();

   @Input() form: UntypedFormGroup;

   @Input() callState: CallState;

   @Input() isSystemUser: boolean;

   @Input() isAdminUser: boolean;

   @Input() fromAccount: boolean;

   @Input() accountId: number | null;

   @Input() numberOfUsers: number | null;

   constructor(private store: Store) {}

   onCloseClick(): void {
      this.formCanceled.emit();
   }

   ngOnInit(): void {
      if (this.fromAccount) {
         this.store.select(getSelectedAccountId).subscribe((accountId) => {
            this.accountId = accountId;
         });
      }
      if (this.numberOfUsers === 0 && (this.isAdminUser || this.isSystemUser)) {
         this.form.get('isAdmin')?.setValue(true);
      }
   }

   onCreate(): void {
      if (this.form.valid) {
         this.formSubmitted.emit();
      }
   }
}
